/**
 * GallerySkeleton — placeholder grid while gallery loads (Phase 4).
 *
 * Figma: 318:4749. Renders 9 placeholder 3:4 cards in a 3-col grid.
 */

import { useTranslation } from 'react-i18next';

const PLACEHOLDERS = Array.from({ length: 9 }, (_, i) => i);

export default function GallerySkeleton() {
  const { t } = useTranslation();
  return (
    <div
      className="grid grid-cols-3 gap-3 px-body-x py-3"
      data-testid="gallery-skeleton"
      aria-label={t('common.loading')}
      aria-busy="true"
    >
      {PLACEHOLDERS.map((i) => (
        <div
          key={i}
          className="w-full rounded-home-16 skeleton-shimmer"
          style={{
            aspectRatio: '3 / 4',
            '--skeleton-base': '#151517',
          }}
        />
      ))}
    </div>
  );
}
